import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { humaniseString } from '../../../utils/stringConversion';
import MessageBox from './MessageBox';
import PlayButton from '../Buttons/PlayButton';

export default class VideoRestrictedMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playClicked: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.access.canIAccess !== nextProps.access.canIAccess) {
      this.setState({ playClicked: false });
    }
  }

  playButtonClick = () => {
    this.setState({ playClicked: true });
  }

  render() {
    const { access } = this.props;
    let readableMinAccessLevel;
    let message;

    if (access.canIAccess === false) {
      readableMinAccessLevel = humaniseString(access.minimum_access_level);

      if (this.state.playClicked === true) {
        if (access.loggedIn === false) {
          const currentPath = location.pathname;
          message = (
            <div className="content-restricted-message">
              <MessageBox border>
                <p className="message-box__title h1 fw-bold">Want to watch this video?</p>
                <p className="h3">This content is restricted to <span className="fw-medium">{readableMinAccessLevel}</span> members.</p>
                <p className="h3">Already a <span className="fw-medium">{readableMinAccessLevel}</span> member? <a href={`/login?returnPath=${currentPath}`}>Login</a> to access this content.</p>
                <p className="h3">Not a member? Sign up to a <span className="fw-medium">{readableMinAccessLevel}</span> plan to gain access to unrivaled coaching content.</p>
                <a href={`/signup?plan_type=${access.minimum_access_level}`} className="btn">{access.minimum_access_level === 'basic' ? 'Sign up for free' : 'Sign up'}</a>
              </MessageBox>
            </div>
          );
        } else {
          message = (
            <div className="content-restricted-message">
              <MessageBox border>
                <p className="message-box__title h1 fw-bold">Want to watch this video?</p>
                <p className="h3">Upgrade to a <span className="fw-medium">{readableMinAccessLevel}</span> membership to watch this video.</p>
                <a href="/account/plan" className="btn">View upgrade options</a>
              </MessageBox>
            </div>
          );
        }
      } else {
        message = (
          <PlayButton onClick={this.playButtonClick} />
        );
      }
    } else {
      message = null;
    }

    return message;
  }
}

VideoRestrictedMessage.propTypes = {
  access: PropTypes.object,
};



// WEBPACK FOOTER //
// ./library/app/components/Global/Messages/VideoRestrictedMessage.js